/*
 ** Initialize the "radarManager" to handle global variables.
 */
  if ( typeof radarManager == "undefined" )
    radarManager = {};

  // Timeout id.
  var timeoutId = null;

/* Launch the separate radar window.  If no parameters passed in, 
   we get them from the current selection in the calendar and pub/ed 
   drop down.  If it comes from the SCs Table icon, we pass in the 
   pubedid (primarykey) of the row clicked on, and get the run date 
   then from the table. 
*/
function launchRadarWindow(pubEdId)
{
  var runDate;
  if( !isUndefinedOrNull(pubEdId) && pubEdId.length === 4 )
  {
    runDate = sT_radarload.getColumnValue(pubEdId, "RUNDATE");
  }
  else
  {
/*    pubEdId = document.radar_load.pubedid.value;
    runDate = document.radar_load.pubeddate_formatted.value;
*/
    alert("Please choose a publication from the table.");    
  }  

  if(runDate.length > 8) { runDate = runDate.substring(0,8); }

  if(runDate.length === 8 && pubEdId.length === 4)
  {
    openURL( "radar", [ "pubedid", "rundate" ], [ pubEdId, runDate ] )
  }
}

function launchLayout (pubEdId) {
  var runDate = sT_radarload.getColumnValue(pubEdId, "RUNDATE");
  if (runDate.length == 8) {
    var pglFilename = runDate + pubEdId + '.out';
    SetProduct( pglFilename, "GEOMFILENAME" );
  } else {
    alert('Invalid run date "'+runDate+'"!');
  }
}

function setRefreshCommand( runDate )
{
  var pubedid = "";
  var rundate = "";
  if ( ! isUndefinedOrNull( runDate ) )
    rundate = runDate;
  else
    rundate = document.radar_load.pubeddate_formatted.value;

  var keys = [ "command", "pubedid", "rundate", "refresh" ];
  var vals = [ "radarload_search", pubedid, rundate, "1" ];
  var url = "spice.pl?" + queryString( keys, vals );

  sT_radarload.setRefreshCommand( url );
}

function performSearch()
{
/* JCO  var pubedid = document.radar_load.pubedid.value; */
  var pubedid = "";
  var rundate = document.radar_load.pubeddate_formatted.value;

  var keys = [ "command", "pubedid", "rundate" ];
  var vals = [ "radarload_search", pubedid, rundate ];

  var url = "spice.pl?" + queryString(keys,vals);
  sT_radarload.loadFromURL2(url);
  setRefreshCommand();
}
 
/*
  Function to call when the calendar is clicked.  This includes clicking
  the previous and next month buttons, and does not always mean the user 
  chose a date.  This is why it is important to check the 
  calendar.dateClicked property.
 */
function radarCalClicked(calendar) 
{
  /* Beware that this function is called even if the end-user only
     changed the month/year. In order to determine if a date was
     clicked you can use the dateClicked property of the calendar.

     MBB: However, since the calendar automatically selects a day in 
     the month as you scroll, we want to always update our inputs.  
     For example, if you select 12/1 and scroll back a month, then 
     calendar automatically highlights and internally selects 11/1.
     This way, the input will always be in sync with the highlighted 
     date the user is viewing in the current month. 
  */
  //if (calendar.dateClicked) 
  //{
    document.radar_load.pubeddate.value = toPaddedLocalDate(calendar.date);
    document.radar_load.pubeddate_formatted.value = getSpiceDate(calendar.date);
/* JCO    updatePubEdList(); */
    
  //}

  var padTwo = MochiKit.DateTime._padTwo;
  var d = calendar.date;

  // Note: Need empty string to force string concatenation 
  // and not numerical addition
  var dStr = d.getFullYear() + "" + padTwo(d.getMonth()+1) + "01";
  if(isUndefinedOrNull(radarManager.dateInfo[dStr]))
  {
    var myCallback = function() 
    { 
      radarManager.calendar.setDate(calendar.date);
      radarManager.calendar._init(radarManager.calendar.firstDayOfWeek, radarManager.calendar.date);
      performSearch();
    }

    var deferred = sendDateInfoRequest(calendar.date)
    deferred.addBoth(myCallback);
  }
  else
  {
    performSearch();
  }
  return;
}

/*
** This timer function prevents the calendar form updating as you scrol
** through dates, after a short pause it updates.
*/
function radarCalTimer( calendar )
{
  if ( isUndefinedOrNull( timeoutId ) ) {
    timeoutId = setTimeout( function() { radarCalClicked( calendar ); }, 1000 );
  } else {
    clearTimeout( timeoutId );
    timeoutId = setTimeout( function() { radarCalClicked( calendar ); }, 1000 );    
  }
}

/*
  Return true if a date should be disabled, false if it should be 
  active.  If a string is returned, that will become the CSS class 
  of that date
*/
function isDateDisabled(someDate)
{
  var n = isUndefinedOrNull;
  someDate = getSpiceDate(someDate).substring(0,8);
  
  // Disable dates with no outext files or runs.
  if( n(radarManager) || 
      n(radarManager.dateInfo) ||
      n(radarManager.dateInfo[someDate]) )
    { return true; }
 
  var d = radarManager.dateInfo[someDate];

  if(d.hasRun || d.hasOutext)
  { 
    // Apply a CSS color to dates with an outext file
    return (d.hasOutext ? " hasOutext " : " ") + (d.hasRun ? " hasRun " : " ");
  }
  
  return true;
}  

/*
  Comparison function to sort the pub/ed select list.  Put blank 
  values first, then sort alphabetically by the <option> text
*/  
function radarSelCmpFunc(a,b)
{
  if(a.value === "")
    { return -1; }
  else if(b.value === "")
    { return 1; }
  else
    { return compare(a.text,b.text); }
}

/*
  Launch an AJAX request and update the contents of the pub/ed 
  select list.  
*/
function updatePubEdList()
{
  var myCallback = function(lrm)
  {
    var sel = document.radar_load.pubedid;
    replaceChildNodes(sel);
    forEachElementChildNode(lrm["xml"], function(c)
    {
      if( c.tagName.substring(0,1) === "p" && 
          c.tagName.length === 5 )
      {
        var pubEdId = c.tagName.substring(1,5);
        var pubEdDesc = (!isUndefinedOrNull(c.firstChild) ? c.firstChild.nodeValue : "");
        appendChildNodes(sel, OPTION( { 'value' : pubEdId,
                                        'class' : 'scs_black' }, 
                                      pubEdDesc) );
      }
    });

    var text = "";
    if(sel.childNodes.length > 0)
      { text = "Please choose a publication..."; }
    else
      { text = "No publications for this date..."; }

    appendChildNodes(sel, OPTION({'value':'','class':'scs_gray'}, text));
    sortSelectOptions(sel,null,null,radarSelCmpFunc);
    setPubEdSelectStyle();
  };

  // Change the select to just show an 'updating' grayed out 
  // option, until we get our AJAX request back...
  var sel = document.radar_load.pubedid;
  replaceChildNodes(sel, OPTION({'value':'','class':'scs_gray'}, "Updating Publications..."));
  setPubEdSelectStyle();

  var contents = formContents(document.radar_load);
  genericAjaxRequest("loadradarpubs", false, myCallback, null, 
                     contents[0], contents[1], 
                     null, null, null, null, true);
  return true;
}

/*
  Call when a new item is selected.  Color the select box gray if 
  it's a blank-valued element, otherwise remove any color style
*/
function setPubEdSelectStyle()
{
  var sel = document.radar_load.pubedid; 
  var btnLaunch = document.radar_load.launch;
  if(sel.value === "") 
  { 
    setStyle(sel, {'color':'gray'}); 
    setNodeAttribute(btnLaunch, "disabled", "disabled");
  }
  else 
  { 
    setStyle(sel, {'color':''}); 
    removeNodeAttribute(btnLaunch, "disabled");
  }

  return true;
}

/*
  Launch an AJAX request to get the run and outext information for 
  the dates in this month so we can properly highlight the calendar.  
  If no date is passed in, we use the current month and year.
  This returns a deferred so you can set actions to take place 
  after we update the dates.
*/
function sendDateInfoRequest(d)
{
  if(isUndefinedOrNull(d)) {
    d = new Date();
  }
    
  if(isUndefinedOrNull(radarManager.dateInfo)) 
    { radarManager.dateInfo = {}; }

  var myCallback = function(jsonObj)
  { 
    if(!isUndefinedOrNull(jsonObj.DateInfo))
    {
      for(var i in jsonObj.DateInfo) 
        { radarManager.dateInfo[i] = jsonObj.DateInfo[i]; } 
    }
  }

  var keys = [ "month", "year" ];
  var vals = [ d.getMonth()+1, d.getFullYear() ];

  // 12th parameter is to use JSON
  return genericAjaxRequest("radar_dateinfo", false, myCallback, null,
                            keys, vals, null, null, null, 
                            null, null, true);
}
